// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__M289M","pulse":"styles_pulse__TOl70","jump":"styles_jump__dY8rA","wiggle":"styles_wiggle__3VU9x"};